import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import FrameTV from "src/Component/FrameTV";
import PanelRight from "src/Component/PanelRight";
import { Button } from "@nocios/presentation-kit";

const PageId = 11;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const page_1 = `${baseImages}page_1.jpeg`;
  const page_2 = `${baseImages}page_2.jpeg`;
  const page_3 = `${baseImages}page_3.jpeg`;
  const page_4 = `${baseImages}page_4.jpeg`;
  const page_5 = `${baseImages}page_5.jpeg`;
  const page_6 = `${baseImages}page_6.jpeg`;
  const page_7 = `${baseImages}page_7.jpeg`;
  const page_8 = `${baseImages}page_8.jpeg`;

  const rightSideComponentStyle: React.CSSProperties = {
    position: "absolute",
    top: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
    width: "100%",
  };

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 400);
    else setStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  const title = "Turn Data into Business Growth";
  const description =
"Leverage powerful insights to drive actionable\ndecisions and measurable ROI. The Infosys\nEntertainment Platform provides an interactive\ndashboard that brings key metrics to life, enabling\nyou to unlock new revenue opportunities and\ndeepen customer engagement.\n\nAnalyze user engagement, ad performance, and\nsubscription trends in real-time to reduce churn,\nboost ARPU, and optimize audience retention. With\nthese insights, your business can stay ahead of\nmarket demands and deliver tailored experiences\nthat resonate."
  const [currentTVPage, setCurrentTVPage] = useState(1);

  const handleNext = () => {
    if (currentTVPage === 8) return;
    setCurrentTVPage(currentTVPage + 1);
  };

  const handleBack = () => {
    if (currentTVPage === 1) return;
    setCurrentTVPage(currentTVPage - 1);
  };

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV>
          <img src={page_1} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 1 ? 1 : 0 }} />
          <img src={page_2} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 2 ? 1 : 0 }} />
          <img src={page_3} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 3 ? 1 : 0 }} />
          <img src={page_4} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 4 ? 1 : 0 }} />
          <img src={page_5} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 5 ? 1 : 0 }} />
          <img src={page_6} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 6 ? 1 : 0 }} />
          <img src={page_7} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 7 ? 1 : 0 }} />
          <img src={page_8} alt="" style={{ ...rightSideComponentStyle, opacity: currentTVPage === 8 ? 1 : 0 }} />

          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200,
              gap: "var(--width-16)",
              marginBottom: "var(--width-16)",
            }}
          >
            <Button style={{ opacity: currentTVPage <= 1 ? 0 : 1 }} onClick={handleBack} startIcon={{ icon: "arrow-right" }} />
            <Button style={{ opacity: currentTVPage >= 8 ? 0 : 1 }} onClick={handleNext} startIcon={{ icon: "arrow-left" }} />
          </div>
        </FrameTV>
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: { gap: "var(--width-16)" },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: { gap: "var(--width-16)" },
    },
  };
};

export default DATA;
